import React from "react";
import { projectTypeOptions } from "../../options/projectTypesOptions";
import { displayFormatDate } from "../../utils/helpers";
const ProjectListDetails = ({ project }) => {
  const getProjectTypeLabel = (value) => {
    const option = projectTypeOptions.find((opt) => opt.value === value);
    return option ? option.label : project?.projectType;
  };
  return (
    <div className="row mb-2 g-0 d-flex align-items-stretch">
      <div className="col-md-6 px-4 mt-2  d-flex flex-column project-details ">
        <div className="row p-2 mt-2 align-items-center">
          <label className="col-md-5  text-black-50 mb-2 ">Project Name</label>
          <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
            {project.projectName}
          </div>
        </div>
        <div className="row p-2 align-items-center">
          <label className="col-md-5  text-black-50 mb-2">Project Type</label>
          <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
            {getProjectTypeLabel(project.projectType)}
          </div>
        </div>
        <div className="row p-2 align-items-center">
          <label className="col-md-5  text-black-50 mb-2">Delivery Lead</label>
          <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
            {project.dlName ? project.dlName : "N/A"}
          </div>
        </div>
        <div className="row p-2  align-items-center">
          <label className="col-md-5  text-black-50 mb-2">
            Project Manager
          </label>
          <div className="col-md-7 px-4 py-2 rounded-2 project-details-field  ">
            {project.projectManagerName || "N/A"}
          </div>
        </div>

        <div className="row p-2 align-items-center">
          <label className="col-md-5  text-black-50 mb-2">
            Principal Sponsor
          </label>
          <div className="col-md-7 px-4 py-2 rounded-2 project-details-field ">
            {project.principalSponsorName || "N/A"}
          </div>
        </div>

        {project.leadBusinessAnalystName && (
          <div className="row p-2 align-items-center">
            <label className="col-md-5 text-black-50 mb-2">
              Lead Business Analyst
            </label>
            <div className="col-md-7 px-4 py-2 rounded-2 project-details-field">
              {project.leadBusinessAnalystName}
            </div>
          </div>
        )}

        <div className="row p-2 align-items-center">
          <label className="col-md-5 text-black-50 mb-2">SOW</label>
          <div className="col-md-7 d-flex gap-2 p-0">
            <div className="position-relative project-date-box">
              <span className="m-0 dateBadgeStyle">Start Date</span>
              <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                {project.sowStartDate
                  ? displayFormatDate(project.sowStartDate)
                  : "Ongoing"}
              </div>
            </div>
            <div className="position-relative project-date-box">
              <span className="m-0 dateBadgeStyle">End Date</span>
              <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                {project.sowEndDate
                  ? displayFormatDate(project.sowEndDate)
                  : "Ongoing"}
              </div>
            </div>
          </div>
        </div>

        <div className="row p-2 align-items-center">
          <label className="col-md-5 text-black-50 mb-2">Actual</label>
          <div className="col-md-7 d-flex gap-2 p-0">
            <div className="position-relative project-date-box">
              <span className="m-0 dateBadgeStyle">Start Date</span>
              <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                {project.startDate
                  ? displayFormatDate(project.startDate)
                  : "Ongoing"}
              </div>
            </div>
            <div className="position-relative project-date-box">
              <span className="m-0 dateBadgeStyle">End Date</span>
              <div className="py-3 px-2 rounded-2 text-center dateBoxStyle">
                {project.endDate
                  ? displayFormatDate(project.endDate)
                  : "Ongoing"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-6 px-4 mt-2 d-flex flex-column project-details">
        <label className=" px-4 mb-2 py-2 mt-3 text-black-50">
          Project Description
        </label>
        <div className="summary-content rounded-2 p-4 flex-grow-1 project-details-field-description project-details-field-description-display ">
          {project.commercialSummary}
        </div>
      </div>
    </div>
  );
};

export default ProjectListDetails;
